import * as React from 'react';

import { Cross } from 'recharts';

type HeadsetSvgProps = React.SVGProps<SVGSVGElement> & {
  width?: number;
  height?: number;
};

const CrossSvg: React.FC<HeadsetSvgProps> = ({ width = 16, height = 16, ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} fill="none" viewBox="0 0 12 12" {...props}>
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.5391 11.1596L0.837891 1.40962L1.41385 0.836539L11.1151 10.5865L10.5391 11.1596Z"
      fill="white"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.1551 1.41022L1.41325 11.1602L0.83849 10.5859L10.5804 0.835938L11.1551 1.41022Z"
      fill="white"
    />
  </svg>
);
export default CrossSvg;
